import { isPlatform } from "@ionic/vue";
import { useSettingsStore } from "@/store/settings"

export default function hasProfile({next, router}: {next: any, router: any}) {
    const { profile } = useSettingsStore()
    if (!profile && isPlatform('desktop'))
        return router.push('/choix-profil')
    else if (!profile && !isPlatform('desktop'))
        return router.push('/bienvenue')
    else
        return next()
}
